import React, { FC } from 'react';

import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import {
  determineIsSubunitCurrency,
  determineParentCurrencyCode
} from 'buyside/util/researchSubmission';

import { IdeaSubmissionAssetFragment, Maybe } from 'interfaces/graphql-typings';

import styles from './positionsStyles.scss';

const PositionAsset: FC<{
  asset: Maybe<IdeaSubmissionAssetFragment>;
  assetLoading: boolean;
}> = ({ asset, assetLoading }) => {
  const { name, entity, primarySymbol, latestPrice, currencyCode } = asset || {};

  return (
    <>
      {assetLoading ? (
        <div>
          <div>
            <h4>
              <Skeleton width={SKELETON_WIDTHS.LARGE} />
            </h4>
            <p>
              <Skeleton width={SKELETON_WIDTHS.SMALL} />
            </p>
            <p>
              <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
            </p>
          </div>
        </div>
      ) : null}
      {asset ? (
        <div>
          <div>
            <p>
              <strong>{name || entity?.name}</strong>
            </p>
            <p>{primarySymbol}</p>
            <p>
              {latestPrice ? (
                <>
                  {latestPrice} {determineParentCurrencyCode(currencyCode || '')}
                  {determineIsSubunitCurrency(currencyCode || '') ? (
                    <label className={styles.positionAssetSubunitCurrency}>
                      ({(latestPrice * 100).toFixed(2)} {currencyCode})
                    </label>
                  ) : null}
                </>
              ) : (
                <i>Recent Price Pending...</i>
              )}
            </p>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PositionAsset;
